<template>
    <generic-account-action
        title="Forgot Password?"
        subtitle="We'll send you an email with a temporary pin if your account exists. You can login with the temporary pin and reset your password in the account settings page."
        :alert="alert"
        :show-overlay="sent"
    >
        <EmailInput
            v-model="email"
            size="lg"
        />
        <b-overlay
            :show="sending"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="primary"
        >
            <b-button
                :disabled="sending"
                variant="primary"
                size="lg"
                block
                @click="sendForgotPassword()"
            >
                <font-awesome-icon icon="envelope"></font-awesome-icon>
                Send
            </b-button>
        </b-overlay>
        <template #overlay>
            <div class="text-center">
                <router-link
                    :to="{ name: 'login_with_password', query: { redirect: '/account/my-account'} }"
                    is="b-button"
                    variant="primary"
                    size="lg"
                >
                    <font-awesome-icon icon="sign-in-alt"></font-awesome-icon>
                    Sign in
                </router-link>
            </div>
        </template>
    </generic-account-action>
</template>
<script>
import GenericAccountAction from './GenericAccountAction.vue';
import EmailInput from '@/components/inputs/EmailInput.vue';

export default {
    components: {
    "generic-account-action": GenericAccountAction,
    EmailInput
},
    data() {
        return {
            sending : false,
            sent    : false,
            alert   : {},
            email   : ""
        };
    },
    mounted() {
        this.email = sessionStorage.getItem("email");
        if(!this.email) {
            this.$router.push({ name: "login" });
        }
    },
    methods: {
        sendForgotPassword() {
            this.sending = true;
            this.$api.post(
                "/api/account/forgotPassword",
                {
                    email: this.email
                }
            ).then((response) => {
                const data = response.data;
                this.sending = false;
                this.sent    = data.success;
                this.alert = {
                    variant: (data.success) ? "success" : "danger",
                    ...data
                };
            }).catch(() => {
                this.sending = false;
                this.alert = {
                    success: false,
                    message: "Internal error while sending email.",
                    variant: "danger"
                };
            });
        }
    }
}
</script>